import { render } from "./DealExplain.vue?vue&type=template&id=7ec9ba89&scoped=true"
import script from "./DealExplain.vue?vue&type=script&lang=js"
export * from "./DealExplain.vue?vue&type=script&lang=js"

import "./DealExplain.vue?vue&type=style&index=0&id=7ec9ba89&scoped=true&lang=css"
import "../../styles/common.css?vue&type=style&index=1&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec9ba89"]])

export default __exports__